import { UserRequestOptions } from '@domain-group/realhub-backend-api-types'

export interface TeamMemberRequestOptions extends UserRequestOptions {
  include_team_member_user?: boolean,
}

const state = {
  id: null,
  member_role: '',
  team_id: undefined,
  team_lead: false,
  user_id: undefined,
}

export const requiredFields = [
  { key: 'member_role' },
  { key: 'team_id' },
  { key: 'user_id' },
]

export default state
